export const WORKBENCH_WIDTH = { min: 960, max: 2560, step: 20, default: 1500 } as const;

export const WORKSPACE_LAYOUT_GRID = {
  columns: 24,
  rowHeight: 20,
  margin: 8,
  legacyColumns: 12,
  legacyScale: { horizontal: 2, vertical: 3 },
} as const;

export const WORKSPACE_LAYOUT_DEFAULT_COMPONENT = {
  x: 0,
  y: 0,
  width: 12,
  height: 12,
} as const;

export type WorkspaceLayoutCoordinates = { x: number; y: number; width: number; height: number };

export function isLegacyWorkspaceLayoutGrid(rootWidth: number): boolean {
  return rootWidth === WORKSPACE_LAYOUT_GRID.legacyColumns;
}

export function migrateLegacyWorkspaceLayout(
  layout: WorkspaceLayoutCoordinates,
): WorkspaceLayoutCoordinates {
  return {
    x: layout.x * WORKSPACE_LAYOUT_GRID.legacyScale.horizontal,
    y: layout.y * WORKSPACE_LAYOUT_GRID.legacyScale.vertical,
    width: layout.width * WORKSPACE_LAYOUT_GRID.legacyScale.horizontal,
    height: layout.height * WORKSPACE_LAYOUT_GRID.legacyScale.vertical,
  };
}
